export const investmentThesisKeys = {
  all: ['investment-theses'] as const,
  list: (accountId: string | null) => ['investment-theses', 'list', accountId] as const,
  holdings: (accountId: string | null) => ['investment-theses', 'holdings', accountId] as const,
  allocation: (accountId: string | null) => ['investment-theses', 'allocation', accountId] as const,
};
